import React from 'react'
import {Table, Typography} from 'antd';
import {Box, Text} from 'grommet';
import type { ColumnsType } from 'antd/es/table';
import {Currency} from "@uniswap/sdk-core";

export interface TokensTableItem {
  token: Currency
  tokenPrice: number | null
  amount: string
}

export interface TokensTableProps {
  data: TokensTableItem[]
  walletAddress: `0x${string}` | undefined
}

export const TokensTable = (props: TokensTableProps) => {
  const columns: ColumnsType<any> = [
    {
      title: 'Token',
      dataIndex: 'token',
      key: 'token',
      width: '160px',
      render: (token) => <Typography.Text>
        {token.name}
      </Typography.Text>,
    },
    // {
    //   title: 'Portfolio %',
    //   dataIndex: 'portfolioPercent',
    //   key: 'portfolioPercent',
    //   width: '200px',
    //   render: (text) => <Typography.Text>{text}</Typography.Text>,
    // },
    {
      title: 'Price (24h)',
      key: 'tokenPrice',
      dataIndex: 'tokenPrice',
      width: '100px',
      render: (tokenPrice: string) => {
        return <Typography.Text>
          {tokenPrice ? `$${(+tokenPrice).toFixed(4)}` : 'N/A'}
        </Typography.Text>
      },
    },
    {
      title: 'Balance',
      dataIndex: 'amount',
      key: 'amount',
      width: '200px',
      render: (amount, item: TokensTableItem) => {
        const amountUSD = item.tokenPrice !== null
          ? `$${(item.tokenPrice * amount).toFixed(2)}`
          : 'N/A'
        return <Box>
          <Text>
            {amountUSD}
          </Text>
          <Text color={'rgb(168, 171, 190)'}>
            {amount} {item.token.name}
          </Text>
        </Box>
      },
    },
  ];

  return <Table
    columns={columns}
    dataSource={props.data}
    pagination={false}
    style={{ backgroundColor: '#323232' }}
  />
}
